import { FC } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { LinkBack, Typography } from '@/components/atoms';
import {
  CategoriesList,
  FiltersList,
  CategoriesListBrand,
} from '@/components/organisms';
import { getLabel } from '@/utils/index';
import { filterValidQueryParams } from '@/utils/Filters';
import { IFiltersPanelCmp } from './IFiltersPanelCmp';
import { useTranslation } from 'next-i18next';

const Panel = styled.div`
  width: 100%;
  position: relative;
`;

const FiltersHeader = styled.div`
  padding: 0 4px;
  margin-bottom: 8px;
  /* border-bottom: 1px solid ${props =>
    props.theme.filterPanel.borderColor}; */
  & > h2 {
    display: inline-block;
    font-size: 20px;
    line-height: 20px;
  }
`;

const Wrapper = styled.div`
  margin-bottom: 48px;
`;

const LinkBackWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: 28px;
  margin-bottom: 8px;
  color: ${props => props.theme.paletteDefault.primary.main};
`;

const LoadingPlaceholder = styled.div`
  min-height: '280px';
`;

const FiltersPanel: FC<IFiltersPanelCmp> = ({
  cmsCollectionTags,
  filters,
  categoryPath,
  type,
  isLoading,
}) => {
  const { t } = useTranslation(['common', 'catalog']);
  const router = useRouter();
  let { slug, p, ...queryParameters } = router.query;

  let validQueryParams = filterValidQueryParams(queryParameters);

  if (slug && !Array.isArray(slug)) {
    slug = [slug];
  }

  let slugBrands = slug as string[];

  if (type === 'brands' && validQueryParams?.['category-path']) {
    slugBrands = [
      ...(slug as string),
      ...(validQueryParams?.['category-path'] as string).split(','),
    ];
  }

  const loadingPlaceholder = (
    <LoadingPlaceholder>{`${t('common:loading')} ...`}</LoadingPlaceholder>
  );
  let browseByList = isLoading ? (
    loadingPlaceholder
  ) : (
    <CategoriesList
      catalogGenders={filters?.gender || []}
      categoryPath={categoryPath || []}
      cmsCollectionTags={{
        ...cmsCollectionTags?.categories,
        gender: cmsCollectionTags?.filters?.gender,
      }}
      slug={type === 'brands' ? slugBrands : (slug as string[])}
      // slug={['barna-cashmere', 'accessories']}
      queryParameters={validQueryParams}
    />
  );

  let browseByListBrand = isLoading ? (
    loadingPlaceholder
  ) : (
    <CategoriesListBrand
      catalogGenders={filters?.gender || []}
      categoryPath={categoryPath || []}
      cmsCollectionTags={{
        ...cmsCollectionTags?.categories,
        gender: cmsCollectionTags?.filters?.gender,
      }}
      slug={type === 'brands' ? slugBrands : (slug as string[])}
      queryParameters={validQueryParams}
    />
  );

  let filterByList = isLoading ? (
    loadingPlaceholder
  ) : (
    <FiltersList
      filters={filters}
      slug={slug as string[]}
      queryParameters={validQueryParams}
    />
  );

  let paramsWithoutCategoryPath = { ...validQueryParams };
  if (type === 'brands' && validQueryParams?.['category-path']) {
    delete paramsWithoutCategoryPath?.['category-path'];
  }

  return (
    <Panel id="filtersPanel">
      <>
        <Wrapper>
          {slug && slug.length >= 2 && type !== 'brands' && (
            <LinkBackWrapper>
              <LinkBack
                href={{
                  pathname: '/collections/[[...slug]]',
                  query: {
                    slug: [slug[0]],
                    ...validQueryParams,
                  },
                }}
                label={`Back to ${getLabel(
                  slug[0],
                  cmsCollectionTags?.filters?.gender
                )}`}
              />
            </LinkBackWrapper>
          )}
          {slug &&
            slug.length === 1 &&
            type === 'brands' &&
            validQueryParams?.['category-path'] && (
              <LinkBackWrapper>
                <LinkBack
                  href={{
                    pathname: '/brands/[slug]',
                    query: {
                      slug: [slug[0]],
                      ...paramsWithoutCategoryPath,
                    },
                  }}
                  label={`Back to ${getLabel(
                    slug[0],
                    cmsCollectionTags?.filters?.gender
                  )}`}
                />
              </LinkBackWrapper>
            )}
          {type === 'brands' ? browseByListBrand : browseByList}
        </Wrapper>
        <Wrapper>
          <FiltersHeader>
            <Typography component="h2" style={{ fontWeight: 600 }}>
              {t('catalog:filters-title')}
            </Typography>
          </FiltersHeader>
          {filterByList}
        </Wrapper>
      </>
    </Panel>
  );
};
export default FiltersPanel;
